export default {
  title: {
    id: 'product_page_reassurance_only_compatible_with',
    defaultMessage: 'Only compatible with',
  },
  showAll: {
    id: 'product_page_reassurance_only_compatible_with_show_all',
    defaultMessage: 'Show all',
  },
  showLess: {
    id: 'product_page_reassurance_only_compatible_with_show_less',
    defaultMessage: 'Show less',
  },
  notCompatible: {
    id: 'product_page_reassurance_only_compatible_with_not_compatible',
    defaultMessage: 'Not compatible with your iPad?',
  },
  seeOther: {
    id: 'product_page_reassurance_only_compatible_with_see_other',
    defaultMessage: 'See other Apple Pencils',
  },
  seeOtherUrl: {
    id: 'product_page_reassurance_only_compatible_with_see_other_url',
    defaultMessage:
      '/en-us/l/apple-pencil/bf4991c4-cdd4-459b-a861-1d17e45ccb90',
  },
}
